import React from 'react';
import {connect} from 'react-redux';
import OptimizeButton from 'components/molecules/optimize-button';
import {BaseDashboard} from '../base-dashboard';

class Dashboard extends BaseDashboard {
    render() {
        const lineupsQuantity = this.getLineupsQuantity();

        return (
            <div className="players-heading">
                <strong>{lineupsQuantity}</strong> Lineups
                <OptimizeButton />
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        lineupsData: {rawLineups},
        filterLineupsByKeyPlayerStackCombinations,
    } = state;

    return {
        rawLineups,
        filterLineupsByKeyPlayerStackCombinations,
    };
}

export default connect(mapStatesToProps)(Dashboard);
